<template>
  <div
    v-if="hasJobs"
    class="deparment">
    <div
      class="dept-name"
      :class="{ open: isOpen }"
      @click="open">
      <p class="h4">{{ department.name }}</p>
      <img
        src="@/assets/img/icon-caret-down.png"
        alt="Arrow Down" />
    </div>
    <Vue3SlideUpDown v-model="isOpen">
      <div class="teams-container">
        <template v-for="team in department.children">
          <template v-if="team.jobs.length">
            <div
              :key="team.id"
              class="team">
              <p
                class="team-name h5"
                v-html="team.name"></p>
              <div
                v-for="job in team.jobs"
                :key="job.id"
                class="job">
                <div class="job-info">
                  <div
                    class="title font-larger"
                    v-html="job.title"></div>
                  <div
                    class="location"
                    v-html="job.location.name"></div>
                </div>
                <a
                  :href="job.absolute_url"
                  class="btn blue"
                  target="_blank"
                  >See the Opportunity</a
                >
              </div>
            </div>
          </template>
        </template>
      </div>
    </Vue3SlideUpDown>
  </div>
  <div
    v-else
    class="no-jobs">
    Currently no open positions in the {{ department.name }} department, please
    check back later.
  </div>
</template>

<script setup>
import { Vue3SlideUpDown } from 'vue3-slide-up-down'
import { ref, onMounted } from 'vue'

const props = defineProps(['department'])

const isOpen = ref(false)

const open = () => {
  isOpen.value = !isOpen.value
}

const hasJobs = ref(false)

const loopChildren = () => {
  props.department.children.forEach((child) => {
    if (child.jobs.length) {
      hasJobs.value = true
      return
    }
  })
}

onMounted(() => {
  loopChildren()
})
</script>

<style lang="scss">
.deparment {
  margin: 0 0 30px;
  background: linear-gradient(180deg, #1d78da 0%, #232e4f 100%);

  @include mobile {
    margin: 0 0 20px;
  }

  &:last-child {
    margin: 0;
  }

  .dept-name {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 3.4rem;
    padding: 18px 40px;

    @include tablet-landscape {
      padding: 18px 30px;
    }

    @include mobile {
      padding: 18px 20px;
    }

    p {
      @include font-main;
    }

    &.open {
      img {
        transform: rotate(180deg);
      }
    }

    img {
      width: 97px;
      transform: rotate(0deg);
      @include transition;

      @include mobile {
        width: 70px;
      }
    }
  }

  .teams-container {
    padding: 50px 0 100px;
    margin: 0 40px;
    border-top: 1px solid $white;

    @include tablet-landscape {
      padding: 40px 0 80px;
      margin: 0 30px;
    }

    @include mobile {
      padding: 30px 0 60px;
      margin: 0 20px;
    }

    &:empty {
      display: none;
    }
  }

  .team {
    width: 90%;
    max-width: 1043px;
    margin: 0 auto 50px;

    @include tablet-landscape(1) {
      width: 100%;
    }

    &:last-child {
      .job:last-child {
        border-bottom: none;
        padding: 0;
        margin: 0;
      }
    }

    @include tablet-landscape(1) {
      padding-left: 20px;
    }

    @include mobile {
      padding: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .team-name {
      margin: 0 0 20px;
      @include font-main;
    }

    .job {
      display: flex;
      padding: 0 0 20px;
      margin: 0 0 20px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.4);

      @include mobile {
        flex-direction: column;
      }

      .job-info {
        flex: 1;
        margin-right: 30px;

        .location {
          margin: 10px 0 0;
        }
      }

      .btn {
        align-self: center;

        @include mobile {
          align-self: flex-end;
          margin: 30px 0 0;
        }
      }
    }
  }
}

.no-jobs {
  display: none;

  &:only-child {
    display: block;
  }
}
</style>
